var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#272727",
  d: "M0 0h16v12H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E31D1C",
  d: "M0 4h16v4H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFD018",
  d: "M0 8h16v4H0z"
})));
export default SvgDe;